// extracted by mini-css-extract-plugin
export default {"f":"_72ab40b95e","main":"_925b4a228a","btn":"_2cfd0e190d","w":"_2238a9d9c8","h":"b5ea6742c9","lh25":"d67bfd6a25","wb":"_53f03f759a","b":"_4f7a0a394e","bx":"c19ea15bc0"};